export const enum VariableVisibility {
    Visible = "visible",
    Hidden = "hidden",
    Readonly = "readonly"
}
